// extracted by mini-css-extract-plugin
export default {"ChatButton":"ChatButton_ChatButton__1HUZJ","ChatButton_hidden":"ChatButton_ChatButton_hidden__3fL9G","ChatButton__badge":"ChatButton_ChatButton__badge__248Zy"};